const CaseStudies = [
  {
    url: "nainital-parking-solution",
    city: "Nainital",
    title: "Parking Management Solution at Nainital",
    image: "https://pm-website-assets.s3.ap-south-1.amazonaws.com/Assets/case_studies/nainital-parking/nainital-cover.png" ,
    summary:
      "The Smart Parking Management system in Nainital leverages AI-powered computer vision and edge computing to monitor real-time vehicle occupancy across key parking zones. Designed for hilly terrain and fluctuating tourist inflow, the system provides live availability updates to the public while offering advanced analytics to authorities. Predictive insights based on historical trends help manage peak congestion periods efficiently. With wireless connectivity, solar-powered options, and centralized dashboard integration, the solution reduces traffic bottlenecks, improves compliance, enhances revenue transparency, and significantly elevates the overall mobility and visitor experience in the city.",
    
    stats: [
      { value: "4", label: "Parkings Covered" },
      { value: "96%", label: "Counting Accuracy" },
      { value: "1150", label: "Parking Capacity" },
    ],

    tags: ["AI Traffic Control", "Smart City", "Urban Mobility"],

    details: {
      head: "Transforming Mumbai’s traffic ecosystem with AI-driven edge computing.",
      para: "The deployment integrated adaptive signal control, emergency prioritization, and real-time analytics across high-density corridors.",
    },
  },

  {
    url: "haridwar-kanwad",
    city: "Haridwar",
    title: "Crowd Monitoring at Har Ki Pauri, Haridwar",
    image: "https://pm-website-assets.s3.ap-south-1.amazonaws.com/Assets/case_studies/haridwar-kanwad/kanwad-cover.png",
    summary:
      "Har Ki Pauri in Haridwar experiences massive footfall during religious events, particularly in the Sawan season and Kanwar Yatra. To enhance safety and streamline movement, an AI-powered, edge-based crowd monitoring system was deployed to provide real-time insights into crowd density and flow patterns. Strategically installed devices processed live video feeds locally, enabling accurate entry-exit counting without relying heavily on network connectivity. Integrated with a centralized dashboard, the system generated timely alerts for authorities, supporting proactive crowd control measures. This data-driven approach significantly improved situational awareness, reduced congestion risks, and strengthened overall public safety management.",
    
    stats: [
      { value: "94%", label: "Counting Accuracy" },
      { value: "25k+", label: "Pilgrims Counted" },
      { value: "8", label: "Entry & Exit Points" },
    ],

    tags: ["AI Traffic Control", "Smart City", "Urban Mobility"],

    details: {
      head: "Transforming Mumbai’s traffic ecosystem with AI-driven edge computing.",
      para: "The deployment integrated adaptive signal control, emergency prioritization, and real-time analytics across high-density corridors.",
    },
  },

  {
    url: "meerut-data-collection",
    city: "Meerut",
    title: "Traffic Data Collection at Meerut",
    image: "https://pm-website-assets.s3.ap-south-1.amazonaws.com/Assets/case_studies/meerut-data-collection/meerut-cover.png",
    summary:
      "This visual illustrates the deployment of intelligent edge devices across key intersections in Meerut city. Strategically distributed across major traffic corridors, each node represents a real-time data collection point capturing classified vehicle movements and flow patterns. The interconnected layout highlights how individual intersections collectively contribute to a unified city-level mobility intelligence network. The depiction emphasizes scalability, distributed processing, and seamless coverage across urban zones. By mapping deployment geographically, the image conveys how localized analytics combine to generate comprehensive traffic insights, supporting congestion reduction, improved planning, and data-driven decision-making throughout the city’s transportation ecosystem.",
    
    stats: [
      { value: "92%", label: "Detection Accuracy" },
      { value: "4.03", label: "Root Mean Square Error" }, 
      { value: "10", label: "Intersections Covered" },
    ],

    tags: ["AI Traffic Control", "Smart City", "Urban Mobility"],

    details: {
      head: "Transforming Mumbai’s traffic ecosystem with AI-driven edge computing.",
      para: "The deployment integrated adaptive signal control, emergency prioritization, and real-time analytics across high-density corridors.",
    },
  },

  {
    url: "Crowd and Traffic Prediction at Kainchi",
    city: "Kainchi",
    title: "Intelligent Mobility for Kainchi Dham",
    image: "https://pm-website-assets.s3.ap-south-1.amazonaws.com/Assets/case_studies/kainchi-dham/kainchi-cover.png",
    summary:
      "Kainchi Dham Temple experiences heavy pilgrim inflow, especially during weekends and spiritual events, leading to congestion and operational strain. Our Smart Traffic and Crowd Management System integrates real-time vehicle analytics, pedestrian density monitoring, and predictive forecasting to ensure safe and efficient movement. By correlating traffic counts with pilgrim arrivals, the system optimizes service rates, dynamically adjusts entry gates, manages parking occupancy, and prevents overcrowding. A centralized dashboard provides actionable insights and automated alerts, enabling proactive decision-making. This data-driven approach enhances safety, reduces waiting time, improves parking turnover, and ensures a seamless, well-organized pilgrimage experience for visitors and authorities alike.",
    
    stats: [
      { value: "96%", label: "Crowd Counting Accuracy" },
      { value: "94%", label: "Traffic Counting Accuracy" },
      { value: "3", label: "Locations" },
    ],

    tags: ["AI Traffic Control", "Smart City", "Urban Mobility"],

    details: {
      head: "Transforming Mumbai’s traffic ecosystem with AI-driven edge computing.",
      para: "The deployment integrated adaptive signal control, emergency prioritization, and real-time analytics across high-density corridors.",
    },
  },



];

export default CaseStudies;